import { Navigate, Route, Routes } from "react-router-dom";
import { AccesoDenegado } from "./auth/AccesoDenegado";
import { CambiarPasswordPage } from "./auth/CambiarPasswordPage";
import { LoginPage } from "./auth/LoginPage";
import { RutaProtegida } from "./auth/RutaProtegida";
import { AppLayout } from "./layout/AppLayout";
import { ActuacionesPage } from "./modules/actuaciones/ActuacionesPage";
import { AgendaPage } from "./modules/agenda/AgendaPage";
import { CentroOperacionesPage } from "./modules/centro-operaciones/CentroOperacionesPage";
import { MiTrabajoPage } from "./modules/mi-trabajo/MiTrabajoPage";
import { ClienteFichaPage } from "./modules/clientes/ClienteFichaPage";
import { ClientesPage } from "./modules/clientes/ClientesPage";
import { ConfiguracionPage } from "./modules/configuracion/ConfiguracionPage";
import { DashboardPage } from "./modules/dashboard/DashboardPage";
import { DocumentosPage } from "./modules/documentos/DocumentosPage";
import { EconomiaPage } from "./modules/economia/EconomiaPage";
import { ExpedienteFichaPage } from "./modules/expedientes/ExpedienteFichaPage";
import { ExpedientesListaPage } from "./modules/expedientes/ExpedientesListaPage";
import { PartesPage } from "./modules/partes/PartesPage";
import { KanbanProcesoPage } from "./modules/procesos/KanbanProcesoPage";
import { ProcesosTrabajoPage } from "./modules/configuracion/ProcesosTrabajoPage";
import { UsuariosPage } from "./modules/usuarios/UsuariosPage";
import { SuperadminCatalogosPage } from "./superadmin/SuperadminCatalogosPage";
import { SuperadminDashboardPage } from "./superadmin/SuperadminDashboardPage";
import { SuperadminLayout } from "./superadmin/SuperadminLayout";
import { SuperadminLoginPage } from "./superadmin/SuperadminLoginPage";
import { SuperadminRutaProtegida } from "./superadmin/SuperadminRutaProtegida";
import { SuperadminTenantsPage } from "./superadmin/SuperadminTenantsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/acceso/:slug" element={<LoginPage />} />

      <Route element={<RutaProtegida />}>
        <Route path="/cambiar-password" element={<CambiarPasswordPage />} />
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/centro-operaciones" element={<CentroOperacionesPage />} />
          <Route path="/mi-trabajo" element={<MiTrabajoPage />} />
          <Route path="/partes" element={<PartesPage />} />
          <Route path="/acceso-denegado" element={<AccesoDenegado />} />
        </Route>
      </Route>

      <Route
        element={
          <RutaProtegida
            permisosRequeridos={["expedientes.ver_todos", "expedientes.ver_asignados"]}
          />
        }
      >
        <Route element={<AppLayout />}>
          <Route path="/expedientes" element={<ExpedientesListaPage />} />
          <Route path="/expedientes/:id" element={<ExpedienteFichaPage />} />
        </Route>
      </Route>

      <Route
        element={<RutaProtegida permisosRequeridos={["clientes.ver"]} />}
      >
        <Route element={<AppLayout />}>
          <Route path="/clientes" element={<ClientesPage />} />
          <Route path="/clientes/:id" element={<ClienteFichaPage />} />
        </Route>
      </Route>

      <Route
        element={<RutaProtegida permisosRequeridos={["actuaciones.ver"]} />}
      >
        <Route element={<AppLayout />}>
          <Route path="/actuaciones" element={<ActuacionesPage />} />
        </Route>
      </Route>

      <Route element={<RutaProtegida permisosRequeridos={["agenda.ver"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/agenda" element={<AgendaPage />} />
        </Route>
      </Route>

      <Route
        element={<RutaProtegida permisosRequeridos={["documentos.ver"]} />}
      >
        <Route element={<AppLayout />}>
          <Route path="/documentos" element={<DocumentosPage />} />
        </Route>
      </Route>

      <Route
        element={<RutaProtegida permisosRequeridos={["economia.ver"]} />}
      >
        <Route element={<AppLayout />}>
          <Route path="/economia" element={<EconomiaPage />} />
        </Route>
      </Route>

      <Route element={<RutaProtegida permisosRequeridos={["usuarios.ver"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/usuarios" element={<UsuariosPage />} />
        </Route>
      </Route>

      <Route
        element={<RutaProtegida permisosRequeridos={["configuracion.ver"]} />}
      >
        <Route element={<AppLayout />}>
          <Route path="/configuracion" element={<ConfiguracionPage />} />
        </Route>
      </Route>

      <Route
        element={<RutaProtegida permisosRequeridos={["procesos.administrar"]} />}
      >
        <Route element={<AppLayout />}>
          <Route path="/configuracion/procesos" element={<ProcesosTrabajoPage />} />
        </Route>
      </Route>

      <Route element={<RutaProtegida permisosRequeridos={["procesos.ver"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/procesos" element={<KanbanProcesoPage />} />
        </Route>
      </Route>

      {/* Nivel plataforma — árbol de rutas completamente separado del estudio:
          sin AppLayout, sin Sidebar/MODULOS, sin RutaProtegida de tenant. */}
      <Route path="/superadmin/login" element={<SuperadminLoginPage />} />
      <Route element={<SuperadminRutaProtegida />}>
        <Route element={<SuperadminLayout />}>
          <Route path="/superadmin" element={<SuperadminDashboardPage />} />
          <Route path="/superadmin/estudios" element={<SuperadminTenantsPage />} />
          <Route path="/superadmin/catalogos" element={<SuperadminCatalogosPage />} />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
